let mode = process.env.VUE_APP_NODE_ENV

export default {
  origin: mode === 'development' ? location.hostname : process.env.VUE_APP_URL
}
